import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        menuShow: true,
        menuOpen: true,
        screenWidth: 0,
        screenHeight: 0,
        watchSt: false,
        watchCal: false,
        strategyTitle: 0,
        marketTitle: 0,
        marketMenu: {},
        marketLock:[],
        newsFlashTitle: 0,
        calShow: false,
        searchShow: false,
        searchKey: '',
        searchLock: true,
        getFreshPrice: true,
        SignedIn: false,
        headImg: {},
        shareShow: false,
        shareMenu: [
            {
                title: '微信',
                icon: 'wechatShare',
                backgroundColor: '#e6f3eb',
                style:'height: 17px;width: 14px'
            },
            {
                title: '朋友圈',
                icon: 'wechatMoments',
                backgroundColor: '#e6f3eb',
                style: 'height: 16px;width: 16px'
            },
            {
                title: 'QQ',
                icon: 'qqShare',
                backgroundColor: '#ecf1fa',
                style: 'height: 15px;width: 16px'
            },
            {
                title: '微博',
                icon: 'sina',
                backgroundColor: '#fff4f4',
                style: 'height: 17px;width: 20px'
            },
        ],


        apiUrl: 'https://papi.tubiaojia.com',
        marketApiUrl: 'https://quote.tubiaojia.com',
        wsUrl: 'wss://quote.tubiaojia.com:8977/ws'


    },
    mutations: {
        watchClient(state) {
            state.screenWidth = document.body.clientWidth;
            state.screenHeight = document.body.clientHeight;
            window.onresize = () => {
                return (() => {
                    state.screenWidth = document.body.clientWidth;
                    state.screenHeight = document.body.clientHeight;
                })();
            }
        }
    },
    actions: {},
    modules: {}
})

